import i18n from 'i18next';

const UNKNOWN =
    'We\'re having troubles creating your account. Please <a href="https://support.rezdy.com/hc/en-us/requests/new?ticket_form_id=360000529213">click here to raise a ticket</a> so that our support team can help you.';

const resources = {
    en: {
        translation: {
            resellerSignUpButtonLabel: 'Setup a free account',
            operatorSignUpButtonLabel: 'Start free trial',
            business: 'Business name',
            countryCode: 'Country',
            phoneNumber: 'Phone number',
            website: 'Website',
            INVALID_COMPANY_URL: 'Please enter a valid website URL (example.com)',
            INVALID_COUNTRY_CODE: UNKNOWN,
            INVALID_USER_NAME: UNKNOWN,
            INVALID_PLAN_NAME: UNKNOWN,
            INVALID_BUSINESS_NAME: 'Business name must contain at least 3 alphanumeric characters',
            BUSINESS_ALIAS_TAKEN:
                'Sorry, the business name you have entered is too common in our system. Please enter a different name.',
            INVALID_PARTNER_SOURCE: UNKNOWN,
            CREATE_COMPANY_ERROR: UNKNOWN,
            UPDATE_TERMS_ERROR: UNKNOWN,
            UNKNOWN,
        },
    },
};

i18n
    // .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        contextSeparator: '@',
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        lng: 'en',
        resources,

        // keySeparator: false, // we do not use keys in form messages.welcome
    });

export default i18n;
